export class TwoKeysMap<V> {
  map: Map<string, V>;
  constructor() {
    this.map = new Map();
  }
  concatKeys(key1: string, key2: string) {
    return `${key1}-${key2}`;
  }
  set(key1: string, key2: string, value: V) {
    const key = this.concatKeys(key1, key2);
    this.map.set(key, value);
  }
  get(key1: string, key2: string) {
    const key = this.concatKeys(key1, key2);
    return this.map.get(key);
  }
  has(key1: string, key2: string) {
    const key = this.concatKeys(key1, key2);
    return this.map.has(key);
  }
  delete(key1, key2) {
    const key = this.concatKeys(key1, key2);
    this.map.delete(key);
  }
  clear() {
    this.map.clear();
  }
  filter(filterFn: (key1: string, key2: string, value: V) => boolean) {
    const filteredMap = new TwoKeysMap<V>();
    this.map.forEach((value, key) => {
      const [key1, key2] = key.split("-");
      if (filterFn(key1, key2, value)) {
        filteredMap.set(key1, key2, value);
      }
    });
    return filteredMap;
  }
}

export class TwoKeysSet {
  set: Set<string>;
  constructor() {
    this.set = new Set();
  }
  concatKeys(key1: string, key2: string) {
    return `${key1}-${key2}`;
  }
  add(key1: string, key2: string) {
    const key = this.concatKeys(key1, key2);
    this.set.add(key);
  }
  has(key1: string, key2: string) {
    const key = this.concatKeys(key1, key2);
    return this.set.has(key);
  }
  delete(key1, key2) {
    const key = this.concatKeys(key1, key2);
    this.set.delete(key);
  }
  clear() {
    this.set.clear();
  }
  forEach(callback: (key1: string, key2: string) => void) {
    this.set.forEach((key) => {
      const [key1, key2] = key.split("-");
      callback(key1, key2);
    });
  }
}
